module.exports = __webpack_public_path__ + "static/media/Heart_diffuse_N.c5ad3978.jpg";